





































import Vue from "vue";

import SessionStatus from "@/views/customize/data-sources/components/SessionStatus.vue";
import { UseModal } from "@/components/root/modal";
import { ScanSession } from "@/views/customize/data-sources/data/model";
import SessionsModal from "@/views/customize/data-sources/modals/source-details/SessionsModal.vue";
export default Vue.extend({
  components: { SessionStatus },
  props: ["sessions", "selected_session"],
  setup(props, { emit }) {
    const show_sessions_modal = async () => {
      const res = await UseModal().show(SessionsModal, {
        // @ts-ignore
        from_sessions: props.sessions,
        // @ts-ignore
        selected_session_id: props.selected_session.id,
      });
      if (res.type == "success") {
        // @ts-ignore
        emit("on_session_selected", res.msg as ScanSession);
      }
    };
    return {
      show_sessions_modal,
    };
  },
});
